document.addEventListener('DOMContentLoaded', function () {
  // Category carousel tab functionality
  const categorySections = document.querySelectorAll('.category-section');

  categorySections.forEach(function (section) {
    const tabButtons = section.querySelectorAll('.tab-btn');
    const tabContents = section.querySelectorAll('.tab-content');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');

        // Remove active class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('tab-btn--active'));

        // Add active class to clicked button
        this.classList.add('tab-btn--active');

        // Hide all tab contents
        tabContents.forEach(content => {
          content.style.display = 'none';
        });

        // Show target tab content
        const targetContent = section.querySelector(`#${targetTab}`);
        if (targetContent) {
          targetContent.style.display = 'block';

          // Reset carousel scroll position to beginning to prevent label cutoff
          const carousel = targetContent.querySelector('.category-carousel');
          if (carousel) {
            carousel.scrollLeft = 0;
          }
        }
      });
    });

    // Handle category card clicks - ensure they navigate properly
    const categoryCards = section.querySelectorAll('.category-card--clickable');
    categoryCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // The link will handle navigation automatically
        // No need to prevent default or add extra logic
      });
    });
  });
}); 